import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RbUiComponentsModule, FormFieldsModule } from '@inst-iot/bosch-angular-ui-components';

import { SupportedVehiclesComponent } from './supported-vehicles/supported-vehicles.component';
import { HomePageComponent } from './home-page/home-page.component';
import { OpenSourceComponent } from './open-source/open-source.component';
import { SharedPipesModule } from '../_shared/modules/shared-pipes.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FleetMgmtModule } from './fleet-mgmt/fleet-mgmt.module';
import { VehiclesMgmtModule } from './vehicles-mgmt/vehicles-mgmt.module';
import { InsightsMgmtModule } from './insights-mgmt/insights-mgmt.module';
import { CustomerDataComponent } from './customer-data/customer-data.component';
import { VehicleOnboardingComponent } from './vehicle-onboarding/vehicle-onboarding.component';
import { CorporateInformationComponent } from './corporate-information/corporate-information.component';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { SettingsComponent } from './settings/settings.component';

@NgModule({
  declarations: [
    DashboardComponent,
    SupportedVehiclesComponent,
    HomePageComponent,
    OpenSourceComponent,
    CustomerDataComponent,
    VehicleOnboardingComponent,
    CorporateInformationComponent,
    LegalNoticeComponent,
    SettingsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RbUiComponentsModule,
    FormFieldsModule,
    SharedPipesModule,
    FleetMgmtModule,
    VehiclesMgmtModule,
    InsightsMgmtModule
  ],
  exports: [
    DashboardComponent
  ]
})
export class DashboardModule { }

